import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import {
  clearHotelMapErrors,
  fetchHotelListMapAsync,
  fetchHotelMapDetailsAsync,
  setHotelMapDetails,
} from './actions';

import type { HotelListMap, HotelListMapErrors } from 'HotelListMap-Types';
import type { HotelItem } from 'HotelList-Types';
export const isFetchingMapList = createReducer(true)
  .handleAction([fetchHotelListMapAsync.request], () => true)
  .handleAction([fetchHotelListMapAsync.success, fetchHotelListMapAsync.failure], () => false);

export const hotelLocations = createReducer({} as HotelListMap)
  .handleAction(fetchHotelListMapAsync.success, (_state, action) => action.payload)
  .handleAction(fetchHotelListMapAsync.failure, () => ({} as HotelListMap));

export const hotelListMapErrors = createReducer([] as HotelListMapErrors[])
  .handleAction([fetchHotelListMapAsync.failure], (_state, action) => action.payload)
  .handleAction([fetchHotelListMapAsync.request], () => [] as HotelListMapErrors[]);

export const isFetchingHotelDetails = createReducer(false)
  .handleAction([fetchHotelMapDetailsAsync.request], () => true)
  .handleAction(
    [fetchHotelMapDetailsAsync.success, fetchHotelMapDetailsAsync.failure],
    () => false,
  );

export const hotelDetails = createReducer({} as HotelItem)
  .handleAction(
    [setHotelMapDetails, fetchHotelMapDetailsAsync.success],
    (_state, action) => action.payload,
  )
  .handleAction(fetchHotelMapDetailsAsync.failure, () => ({} as HotelItem));

export const hotelMapDetailErrors = createReducer({} as HotelListMapErrors)
  .handleAction([fetchHotelMapDetailsAsync.failure], (_state, action) => action.payload)
  .handleAction(
    [fetchHotelMapDetailsAsync.request, clearHotelMapErrors],
    () => ({} as HotelListMapErrors),
  );

const hotelListMapReducer = combineReducers({
  hotelLocations,
  isFetchingMapList,
  hotelListMapErrors,
  hotelDetails,
  isFetchingHotelDetails,
  hotelMapDetailErrors,
});

export default hotelListMapReducer;

export type HotelListMapState = ReturnType<typeof hotelListMapReducer>;
